<template>
    <div class="impression-widget">
        <ul v-if="editing" v-focus-out="onFocusOut" class="slider">
            <li
                v-for="(impression, index) in $iconOptions('impressionEmoji')"
                :key="index"
                @click="onSelectImpression(index)"
            >
                {{ impression }}
            </li>
        </ul>
        <div
            v-if="currentValue !== null && enabled"
            class="impression"
            @click="openSlider()"
        >
            <span class="icon">
                {{ $iconGet("impressionEmoji", currentValue) }}
            </span>
        </div>
        <div
            v-else
            :class="['add-reaction', { disabled: !enabled }]"
            @click="openSlider()"
        >
            <span class="icon material-symbols-outlined">add_reaction</span>
        </div>
    </div>
</template>
<script>
export default {
    name: "ImpressionWidget",
    props: {
        enabled: {
            type: Boolean,
            default: true,
        },
        value: {
            type: Number,
            default: null,
        },
        editMode: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["updated"],
    data() {
        return {
            editing: false,
            currentValue: null,
        };
    },
    mounted() {
        this.currentValue = this.value;
    },
    methods: {
        openSlider() {
            if (!this.enabled || this.editMode) {
                return;
            }

            this.editing = true;
        },
        onFocusOut() {
            this.editing = false;
        },
        onSelectImpression(index) {
            this.editing = false;
            this.currentValue = index;
            this.$emit("updated", index);
        },
    },
};
</script>
